<template lang="pug">
div.d-flex.ml-2
  slot
  v-spacer
  v-btn.mr-2.rounded(
    @click="$emit('reset')"
    v-if="hasSearchValues"
    color="accent"
    height="36px"
    width="36px"
    fab
    tile
  )
    v-icon mdi-close-circle-outline

  v-badge(
    v-if="hasSearchFields"
    :value="hasSearchValues"
    color="success"
    dot
    offset-x="5"
    offset-y="5"
  ).mr-2
    v-btn.rounded(
      @click="$emit('search')"
      height="36px"
      width="36px"
      fab
      tile
      color="primary"
    )
      v-icon(small) mdi-magnify
  v-menu(
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    left
    min-width="290px"
    max-height="80vh"
    offset-overflow
  )
    template(v-slot:activator="{ on }")
      v-badge(
        color="success"
        :value="isAbleToClear"
        dot
        offset-x="5"
        offset-y="5"
      ).mr-2
        v-btn.rounded(
          height="36px"
          width="36px"
          v-on="on"
          fab
          tile
          color="secondary"
        )
          v-icon(small) mdi-cog
    v-card(outlined).pt-2
      v-list
        template(v-if="pinHeader")
          p.text-subtitle-1.px-4.mb-0 Закрепленные
          v-list-item(@dblclick="pin(pinHeader)")
            v-list-item-action.mr-4
              v-icon mdi-flag
            v-list-item-content
              v-list-item-title.text-wrap {{ pinHeader.text || pinHeader.value |  empty }}
          v-divider.mb-2
        p.text-subtitle-1.px-4.mb-0 Видимые поля
        v-list-item.pr-0.px-3(
          @click="toggle(header)"
          v-on:dblclick="pin(header)"
          v-for="(header, index) in allowedHeaders"
          :key="header.value"
          draggable
          :class="dragging === header.value  ? 'primary lighten-1' : ''"
          @dragstart.stop="dragStart($event,header.value)"
          @dragenter="dragOver(header.value)"
          @dragend="dragging = null"
        )
          v-list-item-action.ma-0.mr-2
            v-icon mdi-drag
          v-list-item-action.mr-4
            v-checkbox(
              v-model="selected"
              color="primary"
              :value="header.value"
              @change="toggle(header)"
            )
          v-list-item-content
            v-list-item-title
              span {{ header.text || header.value |  empty }}
          v-list-item-action.flex-row
            v-btn.rounded.mr-2(
              @click.stop.prevent="moveUp(header.value)"
              :disabled="index === 0"
              fab
              height="25px"
              width="25px"
              tile
              text
            )
              v-icon mdi-chevron-up
            v-btn.rounded.mr-2(
              @click.stop.prevent="moveDown(header.value)"
              :disabled="index === allowedHeaders.length - 1"
              fab
              height="25px"
              width="25px"
              tile
              text
            )
              v-icon mdi-chevron-down
      .pa-4.d-flex
        v-btn.mr-auto(
          color="primary"
          @click="menu = false"
        ) Сохранить
        v-btn(
          text
          @click="reset"
        ) Сбросить
          //- :disabled="!isAbleToClear"
</template>

<script>
import difference from 'lodash/difference';

const getSettings = (key) => JSON.parse(localStorage.getItem(key)) || null;
const removeSettings = (key) => localStorage.removeItem(key);
const setSettings = (key, value) => localStorage.setItem(key, JSON.stringify({ ...getSettings(key), ...value })) || {};

export default {
  name: 'Search',
  filters: {
    empty(val) {
      if (val === 'view') return 'Просмотр';
      return val || 'Действия';
    },
  },
  props:{
    hasSearchFields: { type:Boolean, required: false, default:false },
    searchKeys: { type:Object, required: false, default: () => ({}) },
    value: { type: Array, default: () => ([]) },
    headers: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      menu: false,
      selected: [],
      order: [],
      pinHeader: null,

      dragging: null,
    };
  },
  computed: {
    /**
     * Active Headers
     * Список хедеров которые выводятся в таблице
     */
    input: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sourceHeaders() {
      return this.headers.map((h) => h.value);
    },
    allowedHeaders() {
      return this.headers.filter((h) => h.value !== this.pinHeader?.value);
    },
    excludedHeaders() {
      return difference(this.allowedHeaders.map((h) => h.value), this.selected);
    },
    isAbleToClear() {
      // const values = this.headers.map(({ value }) => value);
      // const isSameOrder = JSON.stringify(values) === JSON.stringify(this.order);
      // || isSameOrder;
      return this.excludedHeaders.length || this.pinHeader;
    },
    tableSettingsName() {
      return `table-${this.$route.name}`;
    },
    hasSearchValues() {
      return Object.keys(this.searchKeys).some((key) => this.searchKeys[key]);
    },
  },

  watch: {
    allowedHeaders() {
      this.setActiveHeaders();
    },
    excludedHeaders() {
      this.setActiveHeaders();
    },
  },

  created() {
    this.init();

    this.pinHeader = getSettings(this.tableSettingsName)?.pin || null;
    this.order = (getSettings(this.tableSettingsName)?.order || []).length
      ? getSettings(this.tableSettingsName)?.order
      : this.headers.map(({ value }) => value);
    this.input = this.sortHeaders();
  },

  methods: {
    sortHeaders() {
      return this.headers.sort((a, b) => {
        if (this.order.indexOf(a.value) < this.order.indexOf(b.value)) return -1;
        return 0;
      });
    },

    init() {
      this.selected = getSettings(this.tableSettingsName)?.headers || JSON.parse(JSON.stringify(this.sourceHeaders));
      this.pinHeader = null;
    },

    reset() {
      removeSettings(this.tableSettingsName);
      this.init();
    },

    setActiveHeaders() {
      const pinHeader = this.pinHeader ? [{ ...this.pinHeader, pinned: true }] : [];
      this.input = [...pinHeader, ...this.allowedHeaders.filter((h) => !this.excludedHeaders.includes(h.value))];
    },

    toggle(val) {
      const index = this.selected.indexOf(val.value);

      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(val.value);
      }

      setSettings(this.tableSettingsName, { headers:this.selected });
    },

    reorderHeaders() {
      this.input = this.sortHeaders();

      setSettings(this.tableSettingsName, { order: this.order });
    },

    move(header, value) {
      const index = this.order.findIndex((h) => header === h);
      const temp = this.order[index];
      this.order[index] = this.order[index + value];
      this.order[index +  value] =  temp;
      this.reorderHeaders();
    },

    moveDown(header) {
      this.move(header, 1);
    },

    moveUp(header) {
      this.move(header, -1);
    },

    dragStart(event, header) {
      this.dragging = header;
    },

    dragOver(header) {
      if (header === this.dragging) return;
      if (header) {
        const index = this.order.findIndex((v) => this.dragging === v);
        const targetIndex = this.order.findIndex((v) => header === v);
        if (index > targetIndex) this.moveUp(this.dragging);
        if (index < targetIndex) this.moveDown(this.dragging);
      }
    },

    pin(val) {
      this.pinHeader = this.pinHeader === val ? null : val;
      setSettings(this.tableSettingsName, { pin: this.pinHeader });
    },
  },

};
</script>
<style lang="scss">
.opacity {
  opacity: 0 !important;
}
</style>
